import { Component, EventEmitter, inject, Output } from '@angular/core';
import { CategoryStore } from '../../../stores/category/category.state';
import { TreeModule } from 'primeng/tree';
import { Category } from '../../../models/category';

@Component({
  selector: 'app-category-tree',
  standalone: true,
  imports: [TreeModule],
  templateUrl: './category-tree.component.html',
  styleUrl: './category-tree.component.scss',
})
export class CategoryTreeComponent {
  readonly categoryStore = inject(CategoryStore);
  @Output() categorySelection: EventEmitter<Category> =
    new EventEmitter<Category>();

  /**
   * Handles the selection change event and emits the selected category data.
   *
   * @param $event The event object containing details about the selection change, including the selected item's ID.
   * @return Emits the selected category object retrieved from the categoryStore.
   */
  selectionChange($event: any): void {
    this.categorySelection.emit(this.categoryStore.getById($event._id));
  }
}
